import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';

import type { AutomatedActionDueDate } from '@core/automated-actions-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { getDefaultTimezone } from '@core/time-legacy';
import { DueDateFieldComponent } from '@core/time-ui';
import {
  BadgeComponent,
  FormFieldComponent,
  IconHelpComponent,
  LabelComponent,
  RtTooltip,
} from '@core/user-interface-legacy';
import type { EvaluationDueDateConfig } from '@recruitee/evaluations-types';

@Component({
  selector: 'rt-evaluation-relative-due-date-form-control',
  templateUrl: './evaluation-relative-due-date-form-control.component.html',
  styleUrl: './evaluation-relative-due-date-form-control.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    FormFieldComponent,
    LabelComponent,
    IconHelpComponent,
    BadgeComponent,
    DueDateFieldComponent,
    RtTooltip,
  ],
})
export class EvaluationRelativeDueDateFormControlComponent {
  public readonly value = input<EvaluationDueDateConfig | null>(null);

  public readonly valueChange = output<EvaluationDueDateConfig | null>();

  protected dueDate = computed<AutomatedActionDueDate | null>(() => {
    const value = this.value();

    if (!value || !value.dueDateValue) {
      return null;
    }

    return value.dueDateType === 'absolute'
      ? {
          dueDateType: 'absolute',
          dueDateValue: value.dueDateValue,
          timezone: getDefaultTimezone(),
        }
      : {
          dueDateType: 'relative',
          dueDateUnit: value.dueDateUnit ?? 'days',
          dueDateValue: Number(value.dueDateValue),
          timezone: getDefaultTimezone(),
        };
  });

  protected onDateChange(dueDate: AutomatedActionDueDate | null): void {
    if (!dueDate) {
      this.valueChange.emit(null);
      return;
    }

    this.valueChange.emit({
      dueDateType: dueDate.dueDateType,
      dueDateUnit: 'dueDateUnit' in dueDate ? dueDate.dueDateUnit : null,
      dueDateValue: dueDate.dueDateValue?.toString() ?? null,
    });
  }
}
